'use strict';

var readPullStream = require('./read-pull-stream');

var toStream = require('pull-stream-to-stream');

module.exports = function (ipfs) {
  return function mfsReadReadableStream(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return toStream.source(readPullStream(ipfs)(path, options));
  };
};